var _rect, _circle, _circle2, _path, _path2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAdFox(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 98,
    viewBox: "0 0 98 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      boxShadow: "0px 4px 24px 0px rgba(0, 0, 0, 0.08)",
      borderRadius: 100
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 97,
    height: 97,
    rx: 48.5,
    fill: "white",
    stroke: "#EDEDF0"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 49,
    cy: 49,
    r: 40,
    fill: "url(#paint0_linear_4927_7997)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4927_7997",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 9,
    width: 80,
    height: 80
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 49,
    cy: 49,
    r: 40,
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4927_7997)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.537 39.7865L69.8437 19.1447C69.9058 19.0871 70.0069 19.1281 70.0114 19.2127L71.8358 53.1459C72.2589 61.015 69.3463 68.6981 63.8131 74.3092L37 101.5L3 82.4998L3.5 18.5L25.6225 39.6168C31.736 45.4524 41.3339 45.5267 47.537 39.7865Z",
    fill: "url(#paint1_linear_4927_7997)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_4927_7997",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 18,
    width: 69,
    height: 84
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.537 39.7865L69.8437 19.1447C69.9058 19.0871 70.0069 19.1281 70.0114 19.2127L71.8358 53.1459C72.2589 61.015 69.3463 68.6981 63.8131 74.3092L37 101.5L3 82.4998L3.5 18.5L25.6225 39.6168C31.736 45.4524 41.3339 45.5267 47.537 39.7865Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_4927_7997)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.2336 66.2891L36.5 48L57.5039 65.8922C61.0212 68.8885 66.1334 69.0848 69.8702 66.3671L80 59L49 98.5L7.5 72L7.62563 71.5603C8.2615 69.3347 13.4787 67.7983 15.2336 66.2891Z",
    fill: "url(#paint2_linear_4927_7997)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4927_7997",
    x1: 9,
    y1: 9,
    x2: 89,
    y2: 89,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#303579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F3FA5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4927_7997",
    x1: 67,
    y1: 18,
    x2: 28.5,
    y2: 72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#498AFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.846981,
    stopColor: "#525CFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4927_7997",
    x1: 21,
    y1: 58,
    x2: 54.5,
    y2: 87,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDEB42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.865262,
    stopColor: "#F9CB27"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdFox);
export default __webpack_public_path__ + "static/media/ad-fox.26174bec21658f6bcab9d61d3de096ea.svg";
export { ForwardRef as ReactComponent };